module.exports = __webpack_public_path__ + "img/nodata.b434c3b4.png";